export default __webpack_public_path__ + "static/media/mapPoint .2bb9e23c.svg";